import { generateApi, missingTranslation } from "react-better-html";

import { type APIConfig, type ApiErrorResponse } from "../types/api";

import { LocalStorage } from "./localStorage";
import { i18n } from "./i18n";

import { store } from "../redux/store";

export const api = generateApi<APIConfig>(
   {
      baseUrl: import.meta.env.VITE_API_URL,
      getHeaders: {
         Authorization: () => {
            const cashedFirebaseUserIdToken = LocalStorage.getItem("firebaseUserIdToken");
            const firebaseUserIdToken = store.getState().user.firebaseUserIdToken;

            return firebaseUserIdToken || cashedFirebaseUserIdToken
               ? `Bearer ${firebaseUserIdToken || cashedFirebaseUserIdToken}`
               : undefined;
         },
      },
   },
   {
      userRegister: {
         method: "POST",
         path: "/users/register",
         includeHeaders: ["Authorization"],
      },
      userGetMe: {
         method: "GET",
         path: "/users/me",
         includeHeaders: ["Authorization"],
      },
      editUser: {
         method: "PATCH",
         path: "/users/me",
         includeHeaders: ["Authorization"],
      },

      getAllOrganizations: {
         method: "GET",
         path: "/organizations",
         includeHeaders: ["Authorization"],
      },
      getOrganizationById: {
         method: "GET",
         path: "/organizations",
         includeHeaders: ["Authorization"],
      },
      createOrganization: {
         method: "POST",
         path: "/organizations",
         includeHeaders: ["Authorization"],
      },
      editOrganization: {
         method: "PATCH",
         path: "/organizations",
         includeHeaders: ["Authorization"],
      },

      getAllProperties: {
         method: "GET",
         path: "/organizations",
         includeHeaders: ["Authorization"],
      },
      getAllWorkspaceProperties: {
         method: "GET",
         path: "/workspaces",
         includeHeaders: ["Authorization"],
      },
      getPropertyById: {
         method: "GET",
         path: "/organizations",
         includeHeaders: ["Authorization"],
      },
      getWorkspacePropertyById: {
         method: "GET",
         path: "/workspaces",
         includeHeaders: ["Authorization"],
      },
      createProperty: {
         method: "POST",
         path: "/organizations",
         includeHeaders: ["Authorization"],
      },
      addPropertyToWorkspace: {
         method: "POST",
         path: "/workspaces",
         includeHeaders: ["Authorization"],
      },
      editProperty: {
         method: "PATCH",
         path: "/properties",
         includeHeaders: ["Authorization"],
      },
      propertyOperations: {
         method: "POST",
         path: "/organizations",
         includeHeaders: ["Authorization"],
      },

      getAllWorkspaces: {
         method: "GET",
         path: "/organizations",
         includeHeaders: ["Authorization"],
      },
      getWorkspaceById: {
         method: "GET",
         path: "/workspaces",
         includeHeaders: ["Authorization"],
      },
      createWorkspace: {
         method: "POST",
         path: "/organizations",
         includeHeaders: ["Authorization"],
      },
      editWorkspace: {
         method: "PATCH",
         path: "/workspaces",
         includeHeaders: ["Authorization"],
      },
      workspaceOperations: {
         method: "POST",
         path: "/workspaces",
         includeHeaders: ["Authorization"],
      },
      createWorkspaceShareLink: {
         method: "POST",
         path: "/workspaces",
         includeHeaders: ["Authorization"],
      },
   },
);

export function getErrorMessage(error?: ApiErrorResponse["error"]): string {
   let translatedMessage = error ? i18n.t((l) => (l.api.errors.list as any)[error]) : "";

   if (!translatedMessage || translatedMessage === missingTranslation)
      translatedMessage = i18n.t((l) => l.api.errors.default);

   return translatedMessage;
}
